/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import styled from 'styled-components';

import { getEnv } from '@config';

const { publicPath } = getEnv();

const StyledImage = styled.img`
  ${({ width }) => (typeof width === 'string' ? `width: ${width}` : '')}
  ${({ height }) => (typeof height === 'string' ? `height: ${height}` : '')}
`;

const Image = ({ src, ...props }) => <StyledImage src={`${publicPath}/${src}`} {...props} />;

export default Image;
